import Vue from 'vue'
import store from '../store'
export default {
  accept (id, doctorId) {
    return Vue.http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/accept', {
      doctor_id: doctorId })
  },

  acceptQuery (id, doctorId) {
    return Vue.http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/accept_query', {
      doctor_id: doctorId })
  },

  reject (id, doctorId) {
    return Vue.http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/reject', {
      doctor_id: doctorId
    })
  },

  end (id) {
    return Vue.http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/success', {doctor_id: store.state.configuration.doctorId})
  },

  endIncomplete (id, reasons = []) {
    return Vue.http.post(window.API_URL + 'doctors/consultation_requests/' + id + '/incomplete', {doctor_id: store.state.configuration.doctorId, reasons: reasons})
  },

  load_details () {
    return Vue.http.get(window.API_URL + 'doctors/consultation_requests/load_details')
  }
}



// WEBPACK FOOTER //
// ./src/api/consultation_request.js